import React from 'react'
import PropTypes from 'prop-types'

export interface StarRatingProps {
  blurred?: boolean
  className?: string
  rating: number // TODO: Make this stricter
}

export const StarRating = ({ blurred = false, className = '', rating }: StarRatingProps): React.ReactElement => {
  if (blurred) {
    return <div className='star-rating-container other-ratings blurred' />
  }

  return (
    <div className={`star-rating-container ${className}`}>
      <div className={`star-rating stars-${rating}`} />
    </div>
  )
}

StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
  blurred: PropTypes.bool,
  className: PropTypes.string
}
